import React from "react";

const Spinner = () => (
  <div className="loading">
    <img className="loading__spinner" src="/images/loading.svg" alt="Loading" />
  </div>
);

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.jsx